import { Layout } from "@/components/layout/Layout";
import { HomeHero } from "@/components/home/HomeHero";
import { AirlineCarousel } from "@/components/home/AirlineCarousel";
import { RouteSections } from "@/components/home/RouteSections";
import { CallCta, PaymentOptions } from "@/components/layout/CtaBlocks";
import { FlightFaq } from "@/components/home/FlightFaq";

export default function Home() {
  return (
    <Layout>
      <HomeHero />
      <AirlineCarousel />
      <RouteSections />
      <CallCta />
      <FlightFaq />
      <PaymentOptions />
    </Layout>
  );
}
